<template>
    <my-popup :visible.sync="show">
        <type-wrapper class="contact-popup" padding>
			<!-- 联系我们 -->
			<type-text type="title" size="3">Contact Us</type-text>
			<!-- 请留下您的联系方式，如果一拍即合，我们会马上联系您！ -->
			<type-text type="content" size="9" align="center">Please leave your contact information for personalized offer, we will contact you as soon as possible!</type-text>
			<type-input v-model="name" whitebackdrop placeholder="Name" style="margin-top: 20px;"></type-input>
			<type-input v-model="email" whitebackdrop placeholder="Email" style="margin-top: 20px;"></type-input>
            <type-input v-model="mobile" whitebackdrop placeholder="Phone" style="margin-top: 20px;" :maxlength="mobileMaxlength" prefix>
            	<div class="mobile-prefix" slot="prefix" @click="changePre">{{ mobilePre }}</div>
            </type-input>
			<type-button whitebackdrop border style="margin-top: 40px;" @click="submitInfo">Sure</type-button>
        </type-wrapper>
    </my-popup>
</template>

<script>
	export default {
		name: 'contact',
		data() {
			return {
				// name: '',
				// email: '',
				// mobile: '',
				name: '',
				email: '',
				mobile: '',
				show: false,
				mobilePre: '+1',
                closeResolve: null,
				mobileMaxlength: '10',
				originalOverflow: ''
			}
		},
		methods: {
			showContact() {
				return new Promise(resolve => {
                    this.show = true;
                    this.closeResolve = resolve;
                    this.originalOverflow = document.body.style.overflow;
                    document.body.style.overflow = 'hidden';
				});
			},
			changePre() {
				if (this.mobilePre === '+1') {
					this.mobilePre = '+86';
					this.mobileMaxlength = '11';
				} else {
					this.mobilePre = '+1';
					this.mobileMaxlength = '10';
					if (this.mobile.length > 10) {
						this.mobile = this.mobile.slice(0, 10);
					}
				}
			},
			submitInfo() {
				const data = {
					name: this.name,
					email: this.email,
					mobile: (this.mobilePre === '+1' ? '1' : '+86') + this.mobile
				};
				const result = this.$verify.verify(data);
				// console.log('数据', JSON.parse(JSON.stringify(data)), '验证', JSON.parse(JSON.stringify(result)))
				if (result.tip) {
					this.$message(result.tip);
				} else {
					const content = Object.keys(data).map(key => `${key}=${data[key]}`).join('&');
					this.$http.user.report_bug(content).then(res => {
						if (res.status === 'success') {
							const _data = {
                                ...data,
								time: this.$time.now.timestamp
							};
                            document.body.style.overflow = this.originalOverflow;
                            this.show = false;
                            this.originalOverflow = '';
							this.$message('Submitted');
							this.$userInfo.setData(_data);
                            if (this.closeResolve && typeof this.closeResolve) {
                                this.closeResolve(_data);
                            }
						}
					});
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.contact-popup{
		width: calc(100vw - 90px);
		max-width: 500px;
		min-width: 240px;
		background-color: #FFFFFF;
		.mobile-prefix{
			opacity: 0.75;
			transform: scale(.75);
		}
	}
</style>